/* GIZA MILLS — quantity-break bundle (Kaching-style). Reads variants from #gm-pdp-data and
   tier config + labels from [data-gm-bundle]. Shopper picks colour/size per unit; the tier %
   is applied by a Shopify AUTOMATIC discount (best-value wins) at cart/checkout. Reusable. */
(function () {
  'use strict';
  var box = document.querySelector('[data-gm-bundle]'); if (!box) return;
  var data = {}; try { data = JSON.parse(document.getElementById('gm-pdp-data').textContent); } catch (e) { return; }
  var L = {}; try { L = JSON.parse(box.getAttribute('data-l')); } catch (e) {}
  var tiers = []; try { tiers = JSON.parse(box.getAttribute('data-tiers')); } catch (e) { return; }
  if (!tiers.length) return;

  var base = parseInt(box.getAttribute('data-base'), 10) / 100;
  var currency = box.getAttribute('data-currency') || data.currency || 'EUR';
  var locale = box.getAttribute('data-locale') || 'en';
  var colIdx = data.colorIndex, sizeIdx = data.sizeIndex;
  var colours = data.colours || [], sizes = data.sizes || [], variants = data.variants || [];
  var hasCol = colIdx != null && colours.length > 0;
  var hasSize = sizeIdx != null && sizes.length > 0;

  // custom inset chevron for the slot <select>s (native arrow hugs the edge)
  var CHEV = "data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20width=%2214%22%20height=%2214%22%20viewBox=%220%200%2024%2024%22%20fill=%22none%22%20stroke=%22%238c8a84%22%20stroke-width=%221.6%22%20stroke-linecap=%22round%22%20stroke-linejoin=%22round%22%3E%3Cpath%20d=%22M6%209l6%206%206-6%22/%3E%3C/svg%3E";
  var SELCLS = 'w-full appearance-none border border-line bg-tile/40 pl-3 pr-9 py-2.5 text-[0.85rem] text-ink outline-none focus:border-ink';
  var SELSTYLE = 'background-image:url(\'' + CHEV + '\');background-repeat:no-repeat;background-position:right 0.7rem center';

  function money(v) { try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(v); } catch (e) { return '€' + v.toFixed(2); } }
  function optVal(v, i) { return (v.options || [])[i]; }
  function variantFor(c, z) { return variants.find(function (v) { return (colIdx == null || optVal(v, colIdx) === c) && (!hasSize || optVal(v, sizeIdx) === z); }); }
  function available(c, z) { var v = variantFor(c, z); return !!(v && v.available); }
  function firstSize(c) { for (var i = 0; i < sizes.length; i++) { if (available(c, sizes[i])) return sizes[i]; } return sizes[0]; }
  function currentColour() { var s = document.querySelector('[data-gm-swatch][aria-pressed="true"]'); return s ? s.getAttribute('data-gm-swatch') : (colours[0] || null); }

  var tierEls = box.querySelector('[data-gm-bundle-tiers]');
  var slotEls = box.querySelector('[data-gm-bundle-slots]');
  var totalEl = box.querySelector('[data-gm-bundle-total]');
  var wasEl = box.querySelector('[data-gm-bundle-was]');
  var saveEl = box.querySelector('[data-gm-bundle-save]');
  var addBtn = box.querySelector('[data-gm-bundle-add]');

  var active = 0; tiers.forEach(function (t, i) { if (t.best) active = i; });
  function price(t) { var tot = base * t.q; var disc = tot * (1 - (t.off || 0) / 100); return { tot: tot, disc: disc, unit: disc / t.q, save: tot - disc }; }

  function renderTiers() {
    tierEls.innerHTML = '';
    tiers.forEach(function (t, i) {
      var p = price(t), on = i === active;
      var badge = t.badge ? '<span class="ml-2 rounded-full px-2 py-0.5 align-middle text-[0.55rem] uppercase tracking-[0.16em] ' + (t.best ? 'bg-ink text-paper' : 'bg-tile text-ink-2') + '">' + (L[t.badge] || '') + '</span>' : '';
      var c = document.createElement('button');
      c.type = 'button'; c.setAttribute('data-tier', i);
      c.className = 'relative flex w-full items-center justify-between gap-3 border px-4 py-3.5 text-left transition-all ' + (on ? 'border-ink bg-tile/30' : 'border-line hover:border-ink/40');
      c.innerHTML =
        '<span class="flex items-center gap-3">' +
          '<span class="flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ' + (on ? 'border-ink' : 'border-ink-3') + '">' + (on ? '<span class="h-2 w-2 rounded-full bg-ink"></span>' : '') + '</span>' +
          '<span><span class="pr-label text-ink">' + (L[t.label] || (t.q + '×')) + badge + '</span>' +
            (t.off ? '<span class="mt-0.5 block text-[0.72rem] text-ink-2">' + money(p.unit) + ' ' + (L.each || '') + '</span>' : '<span class="mt-0.5 block text-[0.72rem] text-ink-3">' + money(base) + '</span>') +
          '</span>' +
        '</span>' +
        '<span class="text-right">' + (t.off ? '<span class="block pr-label text-ink">−' + t.off + '%</span><span class="block text-[0.7rem] text-ink-3 line-through">' + money(p.tot) + '</span>' : '') + '</span>';
      tierEls.appendChild(c);
    });
  }

  function colourSelect(sel) {
    var s = '<select data-slot-colour class="' + SELCLS + '" style="' + SELSTYLE + '">';
    colours.forEach(function (c) { s += '<option value="' + c + '"' + (c === sel ? ' selected' : '') + '>' + c + '</option>'; });
    return s + '</select>';
  }
  function sizeSelect(c, sel) {
    var s = '<select data-slot-size class="' + SELCLS + '" style="' + SELSTYLE + '">';
    sizes.forEach(function (z) { var av = available(c, z); s += '<option value="' + z + '"' + (z === sel ? ' selected' : '') + (av ? '' : ' disabled') + '>' + z + (av ? '' : ' · ' + (L.sold || '')) + '</option>'; });
    return s + '</select>';
  }
  function renderSlots() {
    var t = tiers[active], defC = currentColour(); slotEls.innerHTML = '';
    for (var i = 0; i < t.q; i++) {
      var row = document.createElement('div');
      row.className = 'grid items-center gap-2.5 ' + (hasCol && hasSize ? 'grid-cols-[auto_1fr_1fr]' : 'grid-cols-[auto_1fr]');
      row.setAttribute('data-slot', i);
      row.innerHTML = '<span class="pr-eyebrow text-ink-3" style="font-size:0.56rem">' + (L.item || '') + ' ' + (i + 1) + '</span>' +
        (hasCol ? colourSelect(defC) : '') + (hasSize ? sizeSelect(defC, firstSize(defC)) : '');
      slotEls.appendChild(row);
    }
    slotEls.querySelectorAll('[data-slot]').forEach(function (row) {
      var cs = row.querySelector('[data-slot-colour]');
      if (cs) cs.addEventListener('change', function () { var z = row.querySelector('[data-slot-size]'); if (z) z.outerHTML = sizeSelect(cs.value, firstSize(cs.value)); });
    });
  }

  function setButton() { addBtn.textContent = addBtn.getAttribute('data-label-add') || (L.add || 'Add to bag'); }
  function updateSummary() {
    var t = tiers[active], p = price(t);
    totalEl.textContent = money(p.disc);
    if (t.off) { wasEl.textContent = money(p.tot); wasEl.style.display = ''; saveEl.textContent = (L.save || '') + ' ' + money(p.save); saveEl.style.display = ''; }
    else { wasEl.style.display = 'none'; saveEl.style.display = 'none'; }
    setButton();
  }
  function selectTier(i) { active = i; renderTiers(); renderSlots(); updateSummary(); }

  tierEls.addEventListener('click', function (e) { var c = e.target.closest('[data-tier]'); if (c) selectTier(+c.getAttribute('data-tier')); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-gm-swatch]')) setTimeout(renderSlots, 0); });

  function gather() {
    var map = {}, ok = true;
    slotEls.querySelectorAll('[data-slot]').forEach(function (r) {
      var c = hasCol ? r.querySelector('[data-slot-colour]').value : null;
      var z = hasSize ? r.querySelector('[data-slot-size]').value : null;
      var v = variantFor(c, z);
      if (!v || !v.available) { ok = false; return; }
      map[v.id] = (map[v.id] || 0) + 1;
    });
    return { ok: ok, items: Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; }) };
  }
  function add() {
    var g = gather(), t = tiers[active], p = price(t);
    if (!g.ok || !g.items.length) { addBtn.textContent = addBtn.getAttribute('data-label-sold'); setTimeout(setButton, 1600); return; }
    addBtn.disabled = true; var lbl = addBtn.textContent; addBtn.textContent = '…';
    var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: g.items }) })
      .then(function (r) { return r.json(); })
      .then(function () { if (window.GIZA && window.GIZA.openCart) window.GIZA.openCart(); if (window.GIZA && window.GIZA.refreshCart) return window.GIZA.refreshCart(); })
      .then(function () {
        try { if (window.GIZA && window.GIZA.fbq) window.GIZA.fbq('AddToCart', { content_name: data.title, content_ids: [data.handle], content_type: 'product', value: p.disc, currency: currency, num_items: t.q }); } catch (e) {}
        try { if (window.GIZA && window.GIZA.gtag) window.GIZA.gtag('add_to_cart', { currency: currency, value: p.disc, items: [{ item_id: data.handle, item_name: data.title, quantity: t.q, price: p.unit }] }); } catch (e) {}
        try { if (window.GIZA && window.GIZA.klaviyo) window.GIZA.klaviyo('Added to Cart', { $value: p.disc, ProductName: data.title, Price: p.disc, CurrencyCode: currency, URL: data.url }); } catch (e) {}
      })
      .catch(function () {})
      .then(function () { addBtn.disabled = false; addBtn.textContent = lbl; });
  }
  addBtn.addEventListener('click', add);
  document.querySelectorAll('[data-gm-mobile-cta]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); add(); }, true);
  });

  selectTier(active);
})();
